module.exports = __webpack_public_path__ + "static/media/legalex_logo.1290afc0.png";